/* eslint-disable */
import type { Country } from '@/types/country.type'
export const countries: Country[] = require('@/resources/json/countries.json')

export function handle(phoneNumber: string): boolean {
  const country = countries.find(c => phoneNumber.startsWith(c.dial_code))

  if (!country) {
    throw new Error(`No se encontraron reglas para el prefijo del número telefónico: ${phoneNumber}`)
  }

  const phoneWithoutPrefix = phoneNumber.slice(country.dial_code.length)
  const phoneLength = phoneWithoutPrefix.length

  return (
    phoneLength >= country.validation_rules.phone.min_length &&
    phoneLength <= country.validation_rules.phone.max_length
  )
}
